import React from 'react'

function Correct() {
    return (
      <>
        <svg
          width={24}
          height={25}
          viewBox="0 0 24 25"
          fill="none"

          id='correct--icon'
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M12 0.5C5.3832 0.5 0 5.8832 0 12.5C0 19.1168 5.3832 24.5 12 24.5C18.6168 24.5 24 19.1168 24 12.5C24 5.8832 18.6168 0.5 12 0.5ZM12 22.3182C6.58618 22.3182 2.18182 17.9137 2.18182 12.5C2.18182 7.08625 6.58618 2.68182 12 2.68182C17.4138 2.68182 21.8182 7.08625 21.8182 12.5C21.8182 17.9137 17.4137 22.3182 12 22.3182Z"
              fill="#276565"
            />
            <path
              d="M16.4998 8.25738L10.3286 14.4285L7.50023 11.6001C7.07427 11.1741 6.3835 11.174 5.95747 11.6C5.53143 12.026 5.53143 12.7167 5.95747 13.1428L9.55718 16.7426C9.76176 16.9472 10.0392 17.0622 10.3285 17.0622C10.3286 17.0622 10.3285 17.0622 10.3286 17.0622C10.6179 17.0622 10.8954 16.9472 11.0999 16.7427L18.0426 9.80021C18.4686 9.37418 18.4686 8.68349 18.0426 8.25745C17.6165 7.83141 16.9258 7.83134 16.4998 8.25738Z"
              fill="#276565"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width={24}
                height={24}
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </>
    );
}

export  {Correct}
